export interface ResponseTime {
  hiringManagerResponseTimeHours: number;
  hiringManagerResponseTimeMinutes: number;
  hiringManagerResponseTimeDays: number;
}

export function responseTimeAdapter(responseInMinutes): ResponseTime {
  const hoursNumber = Math.floor(responseInMinutes / 60);

  return {
    hiringManagerResponseTimeDays: Math.floor(hoursNumber / 24),
    hiringManagerResponseTimeHours: Math.floor(hoursNumber % 24),
    hiringManagerResponseTimeMinutes: Math.floor(responseInMinutes % 60),
  };
}
